/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type HTMLAttributes, createContext, forwardRef } from 'react';
import { type ContextValue, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';

interface AvatarStatusProps extends Omit<HTMLAttributes<HTMLDivElement>, 'style' | 'className' | 'children'> {
  /** Whether the user is online. (Default: false) */
  isOnline?: boolean;
  /** Size of the status indicator. (Default: 10) */
  size?: keyof typeof sizeVariants;
  style?: stylex.StyleXStyles;
}

const AvatarStatusContext = createContext<ContextValue<AvatarStatusProps, HTMLDivElement>>({});

const AvatarStatus = forwardRef((props: AvatarStatusProps, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, AvatarStatusContext);

  const { style, isOnline = false, size = 10, ...coreProps } = props;

  return (
    <div
      ref={ref}
      {...stylex.props(
        styles.base,
        isOnline && styles.online,
        sizeVariants[size],
        style
      )}
      role="status"
      aria-live="polite"
      aria-label={isOnline ? 'Online' : 'Offline'}
      {...coreProps}
    />
  );
});

const styles = stylex.create({
  base: {
    backgroundColor: $.iconDisabled,
    borderColor: '#EEF0F2',
    borderRadius: '50%',
    borderStyle: 'solid',
    borderWidth: 2,
    boxSizing: 'border-box',
    position: 'absolute',
    transition: 'background-color 0.2s ease-in-out',
  },
  online: {
    backgroundColor: $.surfacePositive,
  }
});

const sizeVariants = stylex.create({
  10: {
    height: 10,
    width: 10,
  },
  11: {
    height: 11,
    width: 11,
  },
  12: {
    height: 12,
    width: 12,
  },
  14: {
    height: 14,
    width: 14,
  },
});

export { AvatarStatus, AvatarStatusContext, type AvatarStatusProps };
